<template>
  <div class="pr-check-tab">
    <div class="radios">
      <label
        v-for="(v, i) in option"
        :key="i + '' + makeSign(v.id)"
        :for="makeSign(v.id)"
        :class="'radio-i' + (act === v.id ? ' act' : '')"
      >
        <input
          :id="makeSign(v.id)"
          v-model="act"
          type="radio"
          :value="v.id"
          :name="name"
        >
        <span>{{ v.text }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PR_CheckTab',
  props: {
    // radio 选项
    option: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 默认选择
    active: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      name: Math.random()
        .toString(36)
        .substring(2),
      act: this.active,
    };
  },
  watch: {
    act: 'onAct',
  },
  mounted() {
    // this.onAct(this.act);
  },
  methods: {
    makeSign(id) {
      return `${this.name}_${id}`;
    },
    onAct(v) {
      this.$emit('change', v);
      this.$emit('update:active', v);
    },
  },
};
</script>

<style lang="less" scoped>
.pr-check-tab {
  .radios {
    height: 51px;
    line-height: 49px;

    .radio-i {
      cursor: pointer;
      text-align: center;
      font-size: 16px;
      padding: 0 8px;
      margin-right: 16px;
      font-family: PingFangSC-Medium;
      font-weight: bold;
      border-bottom: 2px solid transparent;
      color: #303133;
      display: inline-block;

      &.act {
        color: rgba(47, 158, 255, 1);
        border-bottom-color: #2f9eff;
      }

      input {
        position: absolute;
        opacity: 0;
      }
    }
  }
}
</style>
